// Deep copy a copy of data
// 深度 copy 一份数据
import { findSameObj } from '../../modules/store'
import Vue from 'vue'

const cloneDeep = (data) => {
  return JSON.parse(JSON.stringify(data))
}

const initVenueHomeState = {
  // RouterInfo is not cleared
  // routerInfo 不清空
  routerInfo: {},
  // Save country
  // 保存 country
  venueCountry: '',
  // Save timeZone
  // 保存 timeZone
  timeZone: '',
  // Save urlId
  // 保存 urlId
  urlId: '',
  // Save address
  // 保存 address
  address: '',
  // Save phone
  // 保存 phone
  phone: '',
  // Save email
  // 保存 email
  email: '',
  // deliverySetting
  deliverySetting: null,
  // weeklyOperatingHours
  weeklyOperatingHours: null,
  // averageWaitingTime
  averageWaitingTime: 0,
  // systemDefaultWaitingTime
  systemDefaultWaitingTime: 0,
  // peakWaitingTimes
  peakWaitingTimes: null,
  spDiscount: {},
  discountRules: [],
  preOrderSettings: {},
  pickupSettings: {},
  postWidgetSettings: {},
  stationSettings: {},
  isGuests: false,
  alcoholButton: false, // Whether the user manually turns off the alcohol prompt pop-up   // 用户是否手动关闭酒精提示弹框
  customMessageSettings: false,
  // The product information of the restaurant home page needs to be saved in the local cache. If the interface prompts that the data is not updated when requesting the product list interface, this field is directly retrieved from the cache to optimize and improve efficiency
  // 餐厅主页的商品信息，需存到本地缓存中，在请求商品列表接口时，如果接口提示数据无更新，则直接从缓存中取此字段，以此进行优化提升效率
  venueHomeProductInfo: [],
  // The data related to product caching is used to optimize the caching when obtaining products from the restaurant homepage
  // 缓存商品的相关数据，用于对餐厅主页获取商品时，进行缓存优化
  productSession: {
    // Prevent the use of sessionId for optimization when requesting other interfaces later. Add the requested interface name field to facilitate differentiation
    // 请求其他接口时，同样使用 sessionId 进行优化，添加请求的接口名称字段，方便进行区分
    apiName: 'getProductList',
    sessionId: '',
    sessionTime: ''
  },
  enablePaymentGateway: {},
  venueGroupId: null,
  venueGroupSettings: {},
  subGroupId: null,
  subGroupVenueList: {},
  venueSubgroupUnpaidOrderList: [],
  subGroupSettings: {},
  subGroupCartList: {},
  stateVenueId: null,
  creditCardSurchargeLabel: 'Venue Surcharge',
  cartAddProduct: [] // 购物车添加商品列表
}

const module_ = {
  state: cloneDeep(initVenueHomeState),

  mutations: {
    // Initialize state
    // 初始化 state
    resetVenueHomeState(state) {
      for (var i in initVenueHomeState) {
        if (i !== 'subGroupCartList' && i !== 'subGroupVenueList' && i !== 'subGroupSettings') {
          state[i] = initVenueHomeState[i]
        }
      }
    },

    // Save the product information of the restaurant homepage
    // 保存餐厅主页的商品信息
    saveVenueHomeProductInfo(state, productInfo) {
      state.venueHomeProductInfo = productInfo
    },

    saveSubgroupSetting(state, { id, name, setting }) {
      if (!state.subGroupSettings[id]) state.subGroupSettings[id] = {}
      state.subGroupSettings[id][name] = setting
    },

    // save sub group id
    saveSubGroupId(state, id) {
      state.subGroupId = id
    },

    saveStateVenueId(state, id) {
      state.stateVenueId = id
    },

    // Save the unpaid subgroup orderId of each restaurant
    // save 每个subgroup餐馆的未付款 orderId
    saveVenueSubgroupUnpaidOrderList(state, {
      venueSubGroupId,
      unPaidOrderId,
      unPaidOrderNo
    }) {
      const index = state.venueSubgroupUnpaidOrderList.findIndex(item => item.venueSubGroupId === venueSubGroupId)
      if (index === -1) {
        state.venueSubgroupUnpaidOrderList.push({
          venueSubGroupId,
          unPaidOrderId,
          unPaidOrderNo,
        })
      } else {
        state.venueSubgroupUnpaidOrderList.splice(index, 1, {
          venueSubGroupId,
          unPaidOrderId,
          unPaidOrderNo,
        })
      }
    },

    // Clear unpaid subgroup orderId
    // 清除未付款的 sungroup orderId
    // Only one kind of request is allowed. clearUnpaidOrder: pay success
    // 只有 1 种条件下可以 clearUnpaidOrder: pay success
    // 1.card-detail page paysuccess
    // 1.card-detail 页面 paysuccess
    // 2.payment page paysuccess
    // 2.payment 页面 paysuccess
    clearUnpaidVenueSubgroupOrder(state, venueSubGroupId) {
      const index = state.venueSubgroupUnpaidOrderList.findIndex(item => item.venueSubGroupId === venueSubGroupId)
      if (index !== -1) {
        state.venueSubgroupUnpaidOrderList.splice(index, 1)
      }
    },

    deleteVenueSubGroupGoods(state, { venueId, product }) {
      if (state.subGroupCartList[venueId] && state.subGroupCartList[venueId].cart) {
        const filterProductLIst = state.subGroupCartList[venueId].cart
        const currentGoodsIndex = findSameObj(filterProductLIst, product, 'del')
        if (currentGoodsIndex >= 0) {
          filterProductLIst.splice(currentGoodsIndex, 1)
        }
        // Filter out the disableOperation goods (that is, the cartAddProductList goods)
        // 过滤掉 disableOperation 的商品(也就是 cartAddProductList 的商品)
        const productList = filterProductLIst.filter(item => !item.disableOperation)
        // If there is no self selected product, clear the shopping cart
        // 如没有自选商品，就清空购物车
        // if (!productList.length) state.subGroupCartList[venueId].cart = []
      }
    },

    deleteVenueInSubGroupCart(state, venueId) {
      if (state.subGroupCartList[venueId]) {
        Vue.delete(state.subGroupCartList, venueId)
      }
    },

    // save sub group venue list info
    saveSubGroupVenueList(state, list) {
      // console.log('save sub group venue list')
      state.subGroupVenueList = {}

      list.map(item => {
        state.subGroupVenueList[item.id] = { ...item }
      })

      // check need to reset the cart
      for (var i in state.subGroupCartList) {
        if (!state.subGroupVenueList[i]) {
          // console.log('dele sub group cart list ' + i)
          Vue.delete(state.subGroupCartList, i)
        }
      }
    },

    // save subgroup cart list for individual venue
    saveSubGroupVenueCartList(state, { list, cartInfo, venueId }) {
      if (state.subGroupVenueList[venueId]) {
        // 必须走 `Vue.set`：`subGroupCartList` 已经被 Vue 2 observe 过，往它身上
        // **直接加新键**不会建立 getter/setter，这一格就是死的 —— 模板里
        // `v-for="venueCart in subgroupCart"` 不会重新渲染、依赖它的 getter
        // 也不会重算。同一个文件 `:166` / `:183` 删键时用的正是 `Vue.delete`。
        //
        // ⚠️ 键必须**在传进去的那一刻就在**：`Vue.set` 只对传进去的那个值 observe 一次，
        // 给个空对象的话它没有键可 walk，紧跟着的 `.cart = ` / `.cartInfo = ` 又变成
        // 往上面直接加新键 —— 和「整格直接赋值」是同一个毛病，只是下移了一层。
        // 那样第一次 commit 靠 `Vue.set` 自己 notify 还能渲染出来，**第二次起就没有
        // 任何通知源**：顾客点第二下屏幕不动，而结算读的是每次重算的 method-style
        // getter（`store/getters.js:53`）—— 钱按真实件数收，屏幕停在旧数字。
        // 这两个键随后都会被无条件覆盖，所以这里只需要形状正确的空值。
        if (!state.subGroupCartList[venueId]) {
          Vue.set(state.subGroupCartList, venueId, { cart: [], cartInfo: {} })
        }
        // 下面两句同样走 `Vue.set`，理由是**形状不变量**，不是某条今天走得到的路：
        // 上一句只保证「这一格是我们自己刚建的」那种情况两个键齐全。一旦这一格是别处
        // 来的、而且缺了某个键，直接赋值就只是往已 observe 的对象上加新键 —— 加不出
        // getter/setter，这一格从此对模板是死的（`v-for` 不重渲染），而结算读的是每次
        // 重算的 method-style getter（`store/getters.js:53`）：钱按真实件数收、屏幕停在
        // 旧数字。`Vue.set` 在键已经是响应式时会退化成普通赋值并照常 notify，
        // 所以这里**没有行为差异，只有下界**。
        //
        // ⚠️ 诚实标注：「格子在、但缺键」这个前提**今天不可达**，别把下面两句当成在修
        // 线上故障。证据：本仓从 `8adad81e` 起每一版 writer（本方法 / `:235` 的
        // `addNewProductToSubgroupCart` / `:268`）都是两个键一起落地；仓里没有任何一处
        // `delete cell.cart` / `delete cell.cartInfo`；`dropOutdatedCart` 删的是整个
        // `subGroupCartList`，不是格子里的键。真正正在发生的同款故障在
        // `store/modules/contactDetails.js` 的 `addDeliveryInfo`（那条**不需要**任何历史数据）。
        Vue.set(state.subGroupCartList[venueId], 'cart', cloneDeep(list))
        Vue.set(state.subGroupCartList[venueId], 'cartInfo', cloneDeep(cartInfo))
      }
    },

    // 多店：按这家成员店自己的配置重判后的附加费率写回它的 cartInfo（utils/surchargeSnapshot.js refreshSubGroupSurcharges）。
    // 走 `Vue.set`：cartInfo 可能是老数据、缺这两个键（理由同上面 saveSubGroupVenueCartList）。
    saveSubGroupVenueSurcharge(state, { venueId, paymentSurcharge, paymentSurchargeSettings }) {
      const cell = state.subGroupCartList && state.subGroupCartList[venueId]
      if (!cell || !cell.cartInfo) return
      Vue.set(cell.cartInfo, 'paymentSurcharge', paymentSurcharge)
      Vue.set(cell.cartInfo, 'paymentSurchargeSettings', paymentSurchargeSettings)
    },

    // 多店：给缺判定依据的成员店补上门店设置（utils/surchargeSnapshot.js ensureSubGroupSurchargeSources，Codex 第 2 轮 #3 / #4）。
    // 走 `Vue.set`：cartInfo 可能是老数据、缺这两个键（理由同上面 saveSubGroupVenueCartList）。
    saveSubGroupVenueSurchargeSource(state, { venueId, surchargeSource, merchantFee }) {
      const cell = state.subGroupCartList && state.subGroupCartList[venueId]
      if (!cell) return
      if (!cell.cartInfo) Vue.set(cell, 'cartInfo', {})
      Vue.set(cell.cartInfo, 'surchargeSource', surchargeSource)
      Vue.set(cell.cartInfo, 'merchantFee', merchantFee)
    },

    addNewProductToSubgroupCart(state, { product, venueId, cartInfo }) {
      if (state.subGroupVenueList[venueId]) {
        // 门看的是 `subGroupVenueList`（店铺清单），下面读的却是 `subGroupCartList`（购物车）。
        // 两份不是同一时刻建的，所以「门过得去、购物车这一格还不存在」是可达状态 ——
        // 上面兄弟方法 `saveSubGroupVenueCartList` 的同一句就是为此存在的，这里原本漏了。
        // `resetVenueHomeState` 刻意跳过 `subGroupVenueList`，而上线时的购物车清空
        // （`store/cartSchemaVersion.js`）删掉的正是 `subGroupCartList` —— 于是
        // 「店铺清单还在、购物车条目没了」的回头客，会在下一行解引用 undefined。
        //
        // 影响面只有一个调用点：`views/venue-sub-group/cart/index.vue:1754`，
        // 也就是**在子组购物车页点推荐加购**。常规加购走的是 root 的
        // `addNewProductToCart` → `utils/mixin.js:250` 的 `saveSubGroupVenueCartList`，
        // 那条路本来就有存在性初始化，不受影响。
        //
        // 同样必须走 `Vue.set`（理由见上面兄弟方法）：直接赋新键 = 这一格没有反应性，
        // 崩溃会换成**静默写入** —— 购物车页 `v-for` 不渲染这一格、总价停在 0，
        // 而结算读的是每次重算的 method-style getter，钱照收。
        //
        // ⚠️ 内层两个键同样要在 `Vue.set` 的那一刻就带上（理由见上面兄弟方法）。
        // 这里还多一层：`cart` 的数组本身也得被 observe 过，下面命中同款商品时走的
        // `cart.splice(...)` 才会通知 —— 否则「数量加到 2、屏幕还显示 1」。
        // 下面两行留着，是为了兜住「格子已存在但缺键」的历史数据；它们也必须走
        // `Vue.set`，直接赋值同样加不出 getter/setter。
        if (!state.subGroupCartList[venueId]) {
          Vue.set(state.subGroupCartList, venueId, { cart: [], cartInfo: cloneDeep(cartInfo) })
        }
        if (!state.subGroupCartList[venueId].cartInfo) Vue.set(state.subGroupCartList[venueId], 'cartInfo', cloneDeep(cartInfo))
        if (!state.subGroupCartList[venueId].cart) Vue.set(state.subGroupCartList[venueId], 'cart', [])
        // add product
        const index = findSameObj(state.subGroupCartList[venueId].cart, product)
        if (index >= 0) {
          const currentProduct = state.subGroupCartList[venueId].cart[index]
          currentProduct.num = currentProduct.num + product.num
          // If there are combo products, the quantity of the single products should be consistent with that of the combo products
          // 如果有 comboProducts , 则里面的单品数量，要和 combo 的数量一致
          if (currentProduct.comboProducts?.length) {
            currentProduct.comboProducts.forEach(combo => {
              combo.itemList.forEach(item => {
                item.no = currentProduct.num
              })
            })
          }
          state.subGroupCartList[venueId].cart.splice(index, 1, {
            ...product,
            comboProducts: currentProduct.comboProducts,
            num: currentProduct.num,
            recommendFromProductId: currentProduct.recommendFromProductId
          })
        } else {
          // Filter out the disableOperation goods (that is, the cartAddProductList goods)
          // 过滤掉 disableOperation 的商品(也就是 cartAddProductList 的商品)
          const productList = state.subGroupCartList[venueId].cart.filter(item => !item.disableOperation)
          // New products
          // 新增商品
          productList.push({
            ...product
          })
          state.subGroupCartList[venueId].cart = productList
        }
      }
    },

    clearVenueSubGroupProductList(state) {
      state.subGroupCartList = {}
      // Initialize the order type
      // 订单类型，进行初始化
      localStorage.setItem('orderType', '')
    },

    // Save the cache optimization field of the restaurant to obtain goods
    // 保存餐厅获取商品的缓存优化字段
    saveProductSession(state, productSession) {
      state.productSession = productSession
    },

    // SaveRoterInfo saves routing related information, such as table number
    // saveRoterInfo：保存路由的相关信息，例如在保存餐桌号时使用
    saveRouterInfo(state, {
      prop,
      val
    }) {
      state.routerInfo[prop] = val
    },

    // save venue surcharge label
    saveCreditCardSurchargeLabel(state, label) {
      if (label && label !== '') {
        state.creditCardSurchargeLabel = label
      } else label = 'Venue Surcharge'
    },

    // Save country information of venue
    // 保存 venue 的国家信息
    saveVenueCountry(state, country) {
      state.venueCountry = country
    },

    // Save the timeZone of the queue
    // 保存 venue 的 timeZone
    saveVenueTimeZone(state, timeZone) {
      state.timeZone = timeZone
    },

    // Judgment on saving isGuests
    // 保存 isGuests 的判断
    saveVenueIsGuests(state, isGuests) {
      state.isGuests = isGuests
    },

    // Save spDiscount of the venue
    // 保存 venue 的 spDiscount
    saveVenueSpDiscount(state, spDiscount) {
      state.spDiscount = spDiscount
    },

    // Save the urlId of the queue
    // 保存 venue 的 urlId
    saveVenueUrlId(state, urlId) {
      state.urlId = urlId
    },

    // Save the phone of the queue
    // 保存 venue 的 phone
    savePhone(state, phone) {
      state.phone = phone
    },

    // Save the email of the venue
    // 保存 venue 的 email
    saveEmail(state, email) {
      state.email = email
    },

    // Save the address of the queue
    // 保存 venue 的 address
    saveVenueAddress(state, address) {
      state.address = address
    },

    // save venue group id
    saveVenueGroupId(state, id) {
      state.venueGroupId = id
    },

    saveVenueGroupSettings(state, settings) {
      state.venueGroupSettings = settings
    },

    // 保存 venue 的 DeliverySetting
    saveVenueDeliverySetting(state, deliverySetting) {
      if (deliverySetting?.areaSettings?.postcodes?.length) {
        deliverySetting.areaSettings.postcodes = deliverySetting.areaSettings.postcodes.map(item => ({
          ...item,
          zone: item?.name ?? item.zone,
          postcode: item?.postalcode ?? item.postcode
        }))
      }
      state.deliverySetting = deliverySetting
    },

    // Save weeklyOperatingHours of the revenue
    // 保存 venue 的 weeklyOperatingHours
    saveVenueWeeklyOperatingHours(state, weeklyOperatingHours) {
      state.weeklyOperatingHours = weeklyOperatingHours
    },

    // Save the avenue's averageWaitingTime
    // 保存 venue 的 averageWaitingTime
    saveVenueAverageWaitingTime(state, averageWaitingTime) {
      state.averageWaitingTime = averageWaitingTime
    },

    // Save the systemDefaultWaitingTime of the queue
    // 保存 venue 的 systemDefaultWaitingTime
    saveVenueSystemDefaultWaitingTime(state, systemDefaultWaitingTime) {
      state.systemDefaultWaitingTime = systemDefaultWaitingTime
    },

    // Save the peakWaitingTimes of the queue
    // 保存 venue 的 peakWaitingTimes
    saveVenuePeakWaitingTimes(state, peakWaitingTimes) {
      state.peakWaitingTimes = peakWaitingTimes
    },

    // Save discountRules of the avenue
    // 保存 venue 的 discountRules
    saveVenueDiscountRules(state, discountRules) {
      state.discountRules = discountRules
    },

    // save pre-order settings
    saveVenuePreOrderSettings(state, settings) {
      state.preOrderSettings = settings
    },

    // save pickup settings
    saveVenuePickupSettings(state, settings) {
      state.pickupSettings = settings
    },

    // post widget settings
    saveVenuePostWidgetSettings(state, settings) {
      state.postWidgetSettings = settings
    },

    // post station settings
    saveVenueStationSettings(state, settings) {
      state.stationSettings = settings
    },

    saveAlcoholButton(state, alcoholButton) {
      state.alcoholButton = alcoholButton
    },

    saveVenueCustomMessageSettings(state, customMessageSettings) {
      state.customMessageSettings = customMessageSettings
    },

    saveVenueEnablePaymentGateway(state, enablePaymentGateway) {
      state.enablePaymentGateway = enablePaymentGateway
    },

    // Save shopping cart Add item list
    // 保存购物车添加的商品列表
    saveCartAddProduct(state, cartAddProduct) {
      state.cartAddProduct = cartAddProduct
    },
  },
  actions: {},
  getters: {}
}

export default module_
